import { LocalePlayer } from '../en/player'

const player: LocalePlayer = {
  searchPlayers: 'Buscar Jugadores',
  playerProfile: 'Perfil del Jugador',
  MALE: 'HOMBRE',
  FEMALE: 'MUJER',
  signUpToSeeInfo: 'Regístrate para ver las estadísticas del jugador y el historial de partidas',
  loginToSeeInfo: `Inicia sesión o crea una cuenta para ver el récord de victorias y derrotas de este usuario, el promedio de puntos ganados, el promedio de DUPRs de compañeros y oponentes y mucho más.`,
  profileUnlock: {
    title: '¿Usar un desbloqueo?',
    subtitle: 'Usa una de tus vistas de perfil gratis',
    unlock: 'Desbloquear',
    limitReached: 'Límite alcanzado',
    limitReachedSubtitle: 'Mejora a DUPR+ para ver perfiles ilimitados',
    upgrade: 'Mejorar',
    upgradeLink: 'Mejora a ilimitado',
    viewsLeftShort_one: '{{count}} restante',
    viewsLeftShort_other: '{{count}} restantes',
    infoTitle: 'Vistas de perfil gratis',
    info: 'Tienes {{count}} vistas de perfil gratis.',
    resets: 'Se restablece {{when}}.',
    banner: {
      viewsLeft_one: '{{count}} vista restante',
      viewsLeft_other: '{{count}} vistas restantes',
      runningLow: 'Te estás quedando sin vistas',
      freeViewsLeft_one: '{{count}} vista de perfil gratis restante',
      freeViewsLeft_other: '{{count}} vistas de perfil gratis restantes',
      unlockUnlimited: 'Desbloquea perfiles ilimitados',
    },
  },
  filterRatingLocked: 'Mejora a DUPR+ para filtrar por rating',
  ratingLocked: 'Rating bloqueado',
}

export default player
